import React from 'react';

type CircularProgressProps = {
  percentage: number; // 0 to 1
  ringThickness?: number;
  size?: number;
  value?: number | string;
};

export const CircularProgress: React.FC<CircularProgressProps> = (props) => {
  const { percentage, ringThickness = 4, size = 55, value } = props;

  const clampedPercentage = Math.max(0, Math.min(1, percentage));
  const outerRingThickness = 1;
  const innerSize = size - 2 * outerRingThickness;
  const radius = (innerSize - ringThickness) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - clampedPercentage);
  const isFilled = clampedPercentage >= 1.0 && !value;

  return (
    <div
      className={'flex items-center justify-center rounded-full bg-white overflow-hidden'}
      style={{
        height: size,
        width: size,
        padding: outerRingThickness,
      }}
    >
      <div
        className={`w-full h-full rounded-full relative overflow-hidden ${isFilled ? 'bg-[#3d2eff]' : ''}`}
        style={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <svg
          height={innerSize}
          style={{ position: 'absolute', top: 0, left: 0 }}
          width={innerSize}
        >
          <circle
            cx={innerSize / 2}
            cy={innerSize / 2}
            fill="none"
            r={radius}
            stroke="#3d2eff55"
            strokeWidth={ringThickness}
          />
          <circle
            cx={innerSize / 2}
            cy={innerSize / 2}
            fill="none"
            r={radius}
            stroke="#3d2eff"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            strokeWidth={ringThickness}
            style={{ transition: 'stroke-dashoffset 0.5s ease' }}
            transform={`rotate(-90 ${innerSize / 2} ${innerSize / 2})`}
          />
        </svg>
        {value !== undefined && value !== null && (
          <span
            className="text-black z-1"
            style={{ fontSize: size * (percentage >= 1.0 ? 0.21 : 0.26) }}
          >
            {value}
          </span>
        )}
      </div>
    </div>
  );
};
